export default {
      
      

      goToRouter(view) {
            this.$router.push({name: view});
      },       


      enc: function(jsonStr) {            
            return btoa(jsonStr);
      },

      dec: function(str) {
            const decodedJson = atob(str);
            return JSON.parse(decodedJson);
      },

      fillArrayToFive: function(arr) {
            if (!Array.isArray(arr)) return arr;

            const result = [...arr];

            if (result.length === 0) return result;

            const template = result[0];

            while (result.length < 5) {
                  const emptyObj = {};

                  for (const key in template) {
                        const value = template[key];

                        if (typeof value === "number") {
                        emptyObj[key] = 0;
                        } else {
                        emptyObj[key] = "-empty-";
                        }
                  }

                  result.push(emptyObj);
            }

            return result;
      },  
      
      formatDate(date) {
                if (!date) return '';
                
                // Helper function to pad numbers with leading zeros
                const pad = (num) => String(num).padStart(2, '0');
                
                // If it's an array (range mode), format the first date
                if (Array.isArray(date)) {
                    date = date[0];
                }
                
                // If it's a string, convert to Date object
                if (typeof date === 'string') {
                    date = new Date(date);
                }
                
                // Format: YYYY-MM-DD HH:mm
                const year = date.getFullYear();
                const month = pad(date.getMonth() + 1);
                const day = pad(date.getDate());
                const hours = pad(date.getHours());
                const minutes = pad(date.getMinutes());
                
                return `${year}-${month}-${day} ${hours}:${minutes}`;
      },

      formatDateD(date) {
                if (!date) return '';
                
                // Helper function to pad numbers with leading zeros
                const pad = (num) => String(num).padStart(2, '0');
                
                // If it's an array (range mode), format the first date
                if (Array.isArray(date)) {
                    date = date[0];
                }
                
                // If it's a string, convert to Date object
                if (typeof date === 'string') {
                    date = new Date(date);
                }
                
                // Format: YYYY-MM-DD HH:mm
                const year = date.getFullYear();
                const month = pad(date.getMonth() + 1);
                const day = pad(date.getDate());
                
                return `${year}-${month}-${day}`;
      },

      getCamelCase(str) {
                return str.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
      },

      firstLetterCap(str) {
            if (!str) return str;        
            return str[0].toUpperCase() + str.slice(1);
      },


      handleError(errorCode, goToLog, e) {

            this.error = `(${errorCode}) ${e.message}` || "Something went wrong!";
            console.log('hE -'+this.error);

            if (e.customStatus === 'ERR-DIFF' || e.customStatus === 'ERR-SETT') {
            this.error = e.message;
            console.log('hE-i -'+this.error);
            //this.CookieRemove.call(this);
            }

            // if (goToLog && e.response.status === 401) {
            //       console.log('401-'+this.error);
            //       //this.CookieRemove.call(this);
            // }

            // if (e.response.status === 444) {
            //       console.log('444 -'+this.error);
            //       //this.CookieRemove.call(this);
            // }
            
      },   

}